export default [
    { word: 'In', startMs: 0, endMs: 160 },
    { word: 'the', startMs: 160, endMs: 320 },
    { word: 'heart', startMs: 320, endMs: 540 },
    { word: 'of', startMs: 540, endMs: 840 },
    { word: 'whispering', startMs: 840, endMs: 1220 },
    { word: 'woods,', startMs: 1220, endMs: 1940 },
    { word: 'Little', startMs: 2420, endMs: 2720 },
    { word: 'Luna', startMs: 2720, endMs: 3060 },
    { word: 'the', startMs: 3060, endMs: 3280 },
    { word: 'Fox', startMs: 3280, endMs: 3580 },
    { word: 'cub', startMs: 3580, endMs: 4140 },
    { word: 'hopped', startMs: 4140, endMs: 4900 },
    { word: 'from', startMs: 4900, endMs: 5040 },
    { word: 'mossy', startMs: 5040, endMs: 5600 },
    { word: 'stone', startMs: 5600, endMs: 6020 },
    { word: 'to', startMs: 6020, endMs: 6280 },
    { word: 'fern', startMs: 6280, endMs: 6720 },
    { word: 'fringe', startMs: 6720, endMs: 7260 },
    { word: 'log,', startMs: 7260, endMs: 7640 },
    { word: 'her', startMs: 8240, endMs: 8420 },
    { word: 'bright', startMs: 8420, endMs: 8760 },
    { word: 'eyes', startMs: 8760, endMs: 9080 },
    { word: 'dancing', startMs: 9080, endMs: 9580 },
    { word: 'with', startMs: 9580, endMs: 9860 },
    { word: 'curiosity.', startMs: 9860, endMs: 10640 },
    { word: 'She', startMs: 11320, endMs: 11600 },
    { word: 'paused', startMs: 11600, endMs: 12020 },
    { word: 'when', startMs: 12020, endMs: 12300 },
    { word: 'she', startMs: 12300, endMs: 12480 },
    { word: 'heard', startMs: 12480, endMs: 12780 },
    { word: 'a', startMs: 12780, endMs: 12960 },
    { word: 'soft', startMs: 12960, endMs: 13400 },
    { word: 'peep', startMs: 13400, endMs: 14080 },
    { word: 'and', startMs: 14080, endMs: 14560 },
    { word: 'discovered', startMs: 14560, endMs: 15080 },
    { word: 'a', startMs: 15080, endMs: 15340 },
    { word: 'tiny', startMs: 15340, endMs: 15740 },
    { word: 'mouse', startMs: 15740, endMs: 16240 },
    { word: 'caught', startMs: 16240, endMs: 16620 },
    { word: 'in', startMs: 16620, endMs: 16800 },
    { word: 'a', startMs: 16800, endMs: 16960 },
    { word: 'tangle', startMs: 16960, endMs: 17380 },
    { word: 'of', startMs: 17380, endMs: 17720 },
    { word: 'fallen', startMs: 17720, endMs: 18020 },
    { word: 'branches.', startMs: 18020, endMs: 18640 },
    { word: 'With', startMs: 19240, endMs: 19740 },
    { word: 'gentle', startMs: 19740, endMs: 20180 },
    { word: 'paws,', startMs: 20180, endMs: 20660 },
    { word: 'Luna', startMs: 21460, endMs: 21620 },
    { word: 'carefully', startMs: 21620, endMs: 22380 },
    { word: 'nudged', startMs: 22380, endMs: 22940 },
    { word: 'the', startMs: 22940, endMs: 23080 },
    { word: 'twigs', startMs: 23080, endMs: 23420 },
    { word: 'away', startMs: 23420, endMs: 23780 },
    { word: 'until', startMs: 23780, endMs: 24540 },
    { word: 'the', startMs: 24540, endMs: 24740 },
    { word: 'mouse', startMs: 24760, endMs: 25040 },
    { word: 'was', startMs: 25040, endMs: 25320 },
    { word: 'free.', startMs: 25320, endMs: 25760 },
    { word: 'Its', startMs: 26300, endMs: 26740 },
    { word: 'whiskers', startMs: 26740, endMs: 27280 },
    { word: 'twitching', startMs: 27280, endMs: 28060 },
    { word: 'in', startMs: 28060, endMs: 28200 },
    { word: 'gratitude.', startMs: 28200, endMs: 28840 },
    { word: 'Together', startMs: 29520, endMs: 30180 },
    { word: 'they', startMs: 30180, endMs: 30840 },
    { word: 'scurried', startMs: 30840, endMs: 31460 },
    { word: 'through', startMs: 31460, endMs: 31720 },
    { word: 'the', startMs: 31720, endMs: 31900 },
    { word: 'dappled', startMs: 31900, endMs: 32320 },
    { word: 'sunlight,', startMs: 32320, endMs: 32940 },
    { word: 'sharing', startMs: 33740, endMs: 34040 },
    { word: 'tales', startMs: 34040, endMs: 34540 },
    { word: 'of', startMs: 34540, endMs: 34820 },
    { word: 'secret', startMs: 34820, endMs: 35260 },
    { word: 'tunnels', startMs: 35260, endMs: 35720 },
    { word: 'and', startMs: 35720, endMs: 36420 },
    { word: 'hidden', startMs: 36420, endMs: 36800 },
    { word: 'berry', startMs: 36800, endMs: 37180 },
    { word: 'patches,', startMs: 37180, endMs: 37740 },
    { word: 'their', startMs: 38400, endMs: 38640 },
    { word: 'laughter', startMs: 38640, endMs: 39140 },
    { word: 'echoing', startMs: 39140, endMs: 39940 },
    { word: 'through', startMs: 39940, endMs: 40120 },
    { word: 'the', startMs: 40120, endMs: 40320 },
    { word: 'trees', startMs: 40320, endMs: 40660 },
    { word: 'like', startMs: 40660, endMs: 41240 },
    { word: 'a', startMs: 41240, endMs: 41400 },
    { word: 'sweet', startMs: 41400, endMs: 41820 },
    { word: 'cheerful', startMs: 41820, endMs: 42340 },
    { word: 'song.', startMs: 42340, endMs: 43060 },
  ];